import React, { FC, useState } from 'react';
import axios from 'axios';

import Select from '../../common/components/Select';
import ButtonControl from '../../common/components/Select/components/ButtonControl';
import {
  AssignableUser,
  Test,
  Appointment,
  assignTest,
  unassignTest,
  fetchAppointmentTests,
} from './Index';

const MULTI_ASSIGNMENT_OPTION = {
  id: -1,
  fullName: 'Multiple clinicians',
};

const assignAppointment = (appointment: Appointment, userId: number) => {
  fetchAppointmentTests(appointment.id, appointment.testGroup).then((tests) => {
    tests.forEach((test) => {
      if (!userId) {
        unassignTest(appointment, test);
      } else if (test.assignedUser?.id != userId) {
        assignTest(appointment, test, userId);
      }
    });
  });
};

interface AssigneeDropdownProps {
  selectedAppointments?: Appointment[];
  flush?: boolean;
  assignedUser?: {
    id: number;
    fullName: string;
  };
  assignableUsers: AssignableUser[];
  refreshOnAssign?: boolean;
  multiple?: boolean;
  setNewMultiAssignment?: (value: boolean) => void;
}

const AssigneeDropdown: FC<AssigneeDropdownProps> = ({
  selectedAppointments,
  flush = false,
  assignedUser,
  assignableUsers,
  refreshOnAssign = false,
  multiple = false,
  setNewMultiAssignment,
}) => {
  const [value, setValue] = useState(assignedUser?.id);

  const onChange = (userId: number) => {
    if (multiple && userId === MULTI_ASSIGNMENT_OPTION.id) {
      setNewMultiAssignment(true);
      return;
    }
    selectedAppointments.forEach((appointment) =>
      assignAppointment(appointment, userId)
    );

    setValue(userId);

    if (refreshOnAssign) {
      window.location.reload();
    }
  };

  return (
    <Select
      value={value}
      options={
        multiple
          ? [MULTI_ASSIGNMENT_OPTION, ...assignableUsers]
          : assignableUsers
      }
      valueKey="id"
      labelKey="fullName"
      onChange={onChange}
      blankLabel="Unassigned"
      placeholder="Unassigned"
      components={{ Control: ButtonControl }}
    />
  );
};

export default AssigneeDropdown;
